<script setup lang="ts">
import { condOpOptions, registerOrLiteralOptions } from '../../model/inspectorOptions'
import { useFlowEditorContext } from '../../composables/useFlowEditor'
import type { FlowNode } from '../../model/types'

/** Register comparison of a condition node with a live preview of the expression. */
defineProps<{ selectedNode: FlowNode }>()

const editor = useFlowEditorContext()
const { debounced: di, flush: db } = editor.inspector
const { updateCondLeft, updateCondLeftLit, updateCondOp, updateCondRight, updateCondRightLit } =
  editor.inspector
</script>

<template>
  <!-- Condition: register-based comparator -->
  <template v-if="selectedNode.type === 'condition'">
    <label>
      <span>{{ $t('flow.leftOperand') }}</span>
      <select
        :value="selectedNode.data.condLeft ?? 'R1'"
        @change="updateCondLeft(($event.target as HTMLSelectElement).value)"
      >
        <option v-for="r in registerOrLiteralOptions" :key="r.value" :value="r.value">
          {{ r.label }}
        </option>
      </select>
    </label>
    <label v-if="selectedNode.data.condLeft === 'literal'">
      <span>{{ $t('flow.leftLiteralValue') }}</span>
      <input
        type="number"
        :value="selectedNode.data.condLeftLit ?? 0"
        @input="di(updateCondLeftLit)($event)"
        @blur="db(updateCondLeftLit)($event)"
      />
    </label>
    <label>
      <span>{{ $t('flow.operator') }}</span>
      <select
        :value="selectedNode.data.condOp ?? '=='"
        @change="updateCondOp(($event.target as HTMLSelectElement).value)"
      >
        <option v-for="op in condOpOptions" :key="op.value" :value="op.value">
          {{ op.label }}
        </option>
      </select>
    </label>
    <label>
      <span>{{ $t('flow.rightOperand') }}</span>
      <select
        :value="selectedNode.data.condRight ?? 'literal'"
        @change="updateCondRight(($event.target as HTMLSelectElement).value)"
      >
        <option v-for="r in registerOrLiteralOptions" :key="r.value" :value="r.value">
          {{ r.label }}
        </option>
      </select>
    </label>
    <label v-if="selectedNode.data.condRight === 'literal'">
      <span>{{ $t('flow.rightLiteralValue') }}</span>
      <input
        type="number"
        :value="selectedNode.data.condRightLit ?? 0"
        @input="di(updateCondRightLit)($event)"
        @blur="db(updateCondRightLit)($event)"
      />
    </label>
    <div class="flow-settings__cond-preview">
      {{
        selectedNode.data.condLeft === 'literal'
          ? (selectedNode.data.condLeftLit ?? 0)
          : (selectedNode.data.condLeft ?? 'R1')
      }}
      {{ selectedNode.data.condOp ?? '==' }}
      {{
        selectedNode.data.condRight === 'literal'
          ? (selectedNode.data.condRightLit ?? 0)
          : (selectedNode.data.condRight ?? '?')
      }}
    </div>
  </template>
</template>

<style scoped src="../styles/inspectorForm.css"></style>
